import * as ErrorHandlingHelper from "@hireroo/app-helper/error-handling";
import { ScreeningsIdDetailStore } from "@hireroo/app-store/page/e/screenings_id_detail";
import { Snackbar } from "@hireroo/app-store/widget/shared/Snackbar";
import { getGraphqlClient } from "@hireroo/graphql/client/request";
import { useTranslation } from "@hireroo/i18n";
import type { Widget } from "@hireroo/presentation";
import * as Sentry from "@sentry/react";

import SpotTagFieldFetchContainer from "../../../../../../widget/v2/e/TagField/SpotTagFieldFetchContainer";

export type UseTagDialogGeneratePropsArgs = {
  refresh: () => void;
};
export const useTagDialogGenerateProps = (
  args: UseTagDialogGeneratePropsArgs,
): Widget.ScreeningDetailProps["overview"]["reportInfo"]["tagDialog"] => {
  const { t } = useTranslation();
  const client = getGraphqlClient();
  const dialogStatus = ScreeningsIdDetailStore.useDialogStatus();
  const screening = ScreeningsIdDetailStore.useScreening();

  return {
    open: dialogStatus === "OPEN_TAG",
    TagField: <SpotTagFieldFetchContainer name="tags" variant="SECONDARY" />,
    onSubmit: fields => {
      client
        .UpdateScreeningForScreeningDetail({
          input: {
            screeningId: screening.screeningId,
            tagNames: fields.tags?.map(tag => tag.value.name),
          },
        })
        .then(() => {
          args.refresh();
          Snackbar.notify({
            severity: "success",
            message: t("タグを更新しました。"),
          });
        })
        .catch(error => {
          Sentry.captureException(error);
          const errorNotification = ErrorHandlingHelper.generateErrorNotification(error, t("タグの更新に失敗しました。"));
          Snackbar.notify({
            severity: "error",
            message: errorNotification.message,
          });
        })
        .finally(() => {
          ScreeningsIdDetailStore.updateDialogStatus("CLOSE");
        });
    },
    defaultValues: {
      // type is `TemporaryField`
      // https://github.com/hireroo/frontend/blob/9952ab640f3f5d9035ac3a402f5dd8282f2cf750/packages/app_v2/presentation/src/widgets/TagField/TagField.tsx#L48
      tags: screening.tags.map(tag => {
        return {
          value: {
            name: tag.name,
          },
        };
      }),
    },
    onOpen: () => {
      ScreeningsIdDetailStore.updateDialogStatus("OPEN_TAG");
    },
    onClose: () => {
      ScreeningsIdDetailStore.updateDialogStatus("CLOSE");
    },
  };
};
